/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FrameHeaderStyle {
    None = 0,
    Board = 1,
    BrickLintel = 2,
}
